import api from "../../../api";
import router from "../../../router";
import types from "./types";

export default {
  async signUp({ commit }, { email, password, displayname, fullname }) {
    commit("REQUEST_SIGNUP");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_SIGNUP",
        await api.signUp({ email, password, displayname, fullname })
      );
    } catch (err) {
      commit("FAILURE_REQUEST_SIGNUP");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async activateAccount({ commit }, { token }) {
    commit(types.REQUEST_ACTIVATE_ACCOUNT);
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        types.SUCCESS_REQUEST_ACTIVATE_ACCOUNT,
        await api.activateAccount({ token })
      );
    } catch (err) {
      commit(types.FAILURE_REQUEST_ACTIVATE_ACCOUNT);
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async forgotPassword({ commit }, { email }) {
    commit(types.REQUEST_FORGOT_PASSWORD);
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        types.SUCCESS_REQUEST_FORGOT_PASSWORD,
        await api.forgotPassword({ email })
      );
    } catch (err) {
      commit(types.FAILURE_REQUEST_FORGOT_PASSWORD);
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async resetPassword({ commit }, { token }) {
    commit(types.REQUEST_RESET_PASSWORD);
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        types.SUCCESS_REQUEST_RESET_PASSWORD,
        await api.resetPassword({ token })
      );
    } catch (err) {
      commit(types.FAILURE_REQUEST_RESET_PASSWORD);
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async update({ commit }, { id, email, password, displayname }) {
    commit("REQUEST_UPDATE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE",
        await api.update({ id, email, password, displayname })
      );
      router.push({ name: "home" });
    } catch (err) {
      commit("FAILURE_REQUEST_UPDATE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getUser({ commit }) {
    commit("REQUEST_USERS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit("SUCCESS_REQUEST_USERS", await api.getUser());
    } catch (err) {
      commit("FAILURE_REQUEST_USERS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async readUser({ commit }, { id }) {
    commit("REQUEST_USER");
    commit("SET_LOADING", true, { root: true });
    try {
      commit("SUCCESS_REQUEST_USER", await api.readUser({ id }));
    } catch (err) {
      commit("FAILURE_REQUEST_USER");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
